import React from 'react'

function SecondaryButton(props) {
  return (
    <div>
        <button className={`px-[20px] py-[10px] text-[14px] font-medium rounded-md border secondary_btn transition-all duration-500 ${props.classes}`} onClick={props.onClick}>{props.label}</button>
    </div>
  )
}

export default SecondaryButton